/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


import {useEffect, useState} from "react";

export const useTableFilterValues = (defaultFilterValues) => {
	
	const [filterValues, setFilterValues] = useState(defaultFilterValues);
	
	const setFilterValue = (filterCode, value) => {
		// prevent circular rendering when using
		// the legacy support "useCheckForClearedFilters" hook
		if(value === filterValues[filterCode]) {
			return;
		}
		
		setFilterValues({
			...filterValues,
			[filterCode]: value,
		})
	}
	
	return [filterValues, setFilterValue, setFilterValues];
}

export const useUpdateTableFilters = (filters, updateFilters, dependencies = []) => {
	useEffect(() => {
		updateFilters?.(filters?.filter?.(x => !!x.isSet));
	}, dependencies);
}
